$(function() {
  'use strict';


  /**
   *  Amazonの商品情報を表示
   **/
  var connecting = false;


  /**
   * Amazonの商品を表示
   **/
  function showAmazonItems( nodes, callback ) { 

    if ( !callback ) {
      callback = function() {};
    }

    //同時接続しないようにする処理
    if ( connecting ) {
      setTimeout( function() {
        showAmazonItems( nodes, callback );
      },500);
      return;
    }

    connecting = true;
    var req_items = {};
    var nonce;

    nodes.each( function( node ) {
      var req_id = $(this).data('req-id');
      var asin = $(this).data('asin');
      var title = $(this).data('title');
      var list_price = $(this).data('list-price');
      var sale_price = $(this).data('sale-price');
      var mode = $(this).data('mode');
      var style = $(this).data('style');
      var image_width = $(this).data('image_width');
      var image_height = $(this).data('image_height');
      var sale = $(this).data('sale');
      var cache = $(this).data('cache');
      var nonce = $(this).data('nonce');
      var version = $(this).data('version');
      var is_new_template_v2 = $(this).data('is-new-template-v2');
      req_items[req_id] = {
        'asin' : asin,
        'title' : title,
        'mode' : mode,
        'style' : style,
        'image_width' : image_width,
        'image_height' : image_height,
        'sale' : sale,
        'list_price' : list_price,
        'sale_price' : sale_price,
        'cache' : cache,
        'nonce' : nonce,
        'version' : version,
        'is_new_template_v2': is_new_template_v2,
      };
    });
    console.log('req_items',req_items);

    $.ajax({
      url: moko.ajaxurl,
      type: 'POST',
      dataType: 'json',
      timeout: 30000,
      cache : false,
      data: {
        'action': 'moko_amazon_item',
        'req_items': JSON.stringify(req_items),
      }
    }).
    fail(function(xhr, status, error) {
      showMessage( nodes, '通信エラーが発生しました');
      var error_message = "amazon_item:"+error+":"+status+":"+xhr.status ;
      console.error( error_message );
      ga("all.send", "exception", { "exDescription": error_message } );
    }).
    done(function(data) {

      if ( data.data && data.data.error ) { 
        showMessage( nodes, data.data.error ); 
      } else {
        for ( var req_id in data ) {
            showAmazonItem(req_id, data[req_id]);
        }
      }
    }).always(function() {
      connecting = false;
      callback();
    });
  }


  function showAmazonList( node, callback ) { 

    if ( !callback ) {
      callback = function() {};
    }

    var filters = $(node).data('filters');
    //console.log(filters);
    var ttl = $(node).data('ttl');
    var nonce = $(node).data('nonce');
    var is_new_template_v2 = $(node).data('is-new-template-v2');
    var req = {
      'filters' : filters,
      'ttl' : ttl,
      'nonce' : nonce,
      'is_new_template_v2': is_new_template_v2,
    };
    //console.log('req',req);

    $.ajax({
      url: moko.ajaxurl,
      type: 'POST',
      dataType: 'json',
      timeout: 30000,
      cache : false,
      data: {
        'action': 'moko_amazon_list',
        'request': JSON.stringify(req),
      }
    }).
    fail(function(xhr, status, error) {
      showMessage( nodes, '通信エラーが発生しました');
      var error_message = "amazon_item:"+error+":"+status+":"+xhr.status ;
      console.error( error_message );
      ga("all.send", "exception", { "exDescription": error_message } );
    }).
    done(function(data) {
      //console.log(data)
      $(node).html(data);
    }).always(function() {
      callback();
    });
  }


  function showAmazonItem(req_id, html) {
    $('.amazon-item-'+req_id).html(html);
  }

  function showMessage( node, message ) {
    node.find('.amazon-item-error').html(message);
  }


  /**
   *  Amazonの商品情報を取得する
   **/
  moko.initAmazonItems = function( content ) { 
   
    var nodes = [];

    var onece_num = 10;
    var all_nodes = content.find('.ajax-amazon-item');
    var slice_num = Math.ceil( all_nodes.length / onece_num );
    for ( var i = 0; i < slice_num ; i++ ) {
      nodes = all_nodes.slice( i*onece_num, (i*onece_num)+onece_num);
      showAmazonItems( nodes );
    }

    content.find('.ajax-amazon-list').each( function( node ) {
      showAmazonList( this );
    });
  };



  moko.initAmazonItems($(document));

});
